import React from 'react';
import { useSelector } from 'react-redux';
import { getUserData } from 'store/selectors/user';
import { useGetSurveyByCourseIdQuery, useGetSurveyByUserIdQuery } from 'store/services/feedbackGroup';
import DividerWithText from 'style-guide/DividerWithText';
import Skeleton from 'style-guide/Skeleton';
import Text from 'style-guide/Typography/Text';
import ChapterChartComponent from './ChapterChartComponent';
import ChartComponent from './Chart';
import RadarChartWrapper from './style/RadarChartWrapper';

const RadarChart = ({ courseId, chapterId, chapter }) => {
  const user = useSelector(getUserData);

  const { data: feedbackGroupsByCourse, isLoading: isLoadingCourse } = useGetSurveyByCourseIdQuery(
    { courseId },
    { skip: !courseId }
  );

  const { data: surveyData, isLoading: isLoadingUser } = useGetSurveyByUserIdQuery(
    {
      userId: user?.id ? +user.id : undefined,
      chapterId: chapterId ? +chapterId : undefined,
    },
    { skip: !user?.id || !chapterId }
  );

  const surveyResult = surveyData?.[0]?.feedbackGroups;
  const maxPoint = chapterId ? surveyData?.[0]?.maxPoint : feedbackGroupsByCourse?.[0]?.maxPoint;

  const isLoading = isLoadingCourse || isLoadingUser;

  // No survey case
  const noSurvey =
    !isLoading &&
    !courseId &&
    ((!chapterId && !feedbackGroupsByCourse?.length) || (chapterId && (!surveyData || surveyData.length === 0)));

  return (
    <RadarChartWrapper>
      {isLoading && (
        <div className='d-flex justify-content-center mt--24'>
          <Skeleton skeleton={{ height: 400, width: 800 }} />
        </div>
      )}
      {courseId && !isLoading ? (
        <ChapterChartComponent chapterId={chapter?.id} maxPoint={maxPoint} />
      ) : (
        surveyResult &&
        surveyResult.length > 0 && (
          <div className='d-flex justify-content-center'>
            <ChartComponent feedbackGroups={surveyResult} maxPoint={maxPoint} />
          </div>
        )
      )}
      {noSurvey && (
        <div className='mt--48 text-align-center'>
          <Text>This chapter does not have any survey attached.</Text>
          <DividerWithText />
        </div>
      )}
    </RadarChartWrapper>
  );
};

export default RadarChart;
